module.exports = __webpack_public_path__ + "img/4.b7525c52.png";